export default __webpack_public_path__ + "static/index-sample-02-e98d01ff52c405a4ed946ae35e2b07b7.jpg";